import React, { useContext } from "react";
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Container from '@mui/material/Container';
import UserTab from "./UserTab";
import { AuthContext } from "../../../context";
import { CONFIG } from "../../../config";
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';


function Header() {
  const { user, logout } = useContext(AuthContext);


  const openAlivPage = () => {
    console.log('ff');
    window.open(`${CONFIG.ALIV_URL}/LifeGuard`, "_self");
  }
  return (
    <section id="site-header-root">
      <AppBar position="static">
        <Container maxWidth="xl">
          <Toolbar disableGutters>
            {/* <Box sx={{ display: { xs: 'flex', md: 'none' }, mr: 1 }} className="mobile-brand"  >
              <h6 onClick={() => openAlivPage()}> <ArrowBackRoundedIcon />Back to Aliv</h6>
            </Box> */}
            <Box sx={{ display: { sm: 'flex' } }} className="desktop-brand"  >
              <h6 onClick={() => openAlivPage()}> <ArrowBackRoundedIcon />Back to Aliv</h6>
            </Box>
            <Box sx={{ flexGrow: 1, display: { xs: 'flex', justifyContent: 'end' } }}  >
              {user ? (<UserTab user={user} logout={logout} />) : (<></>)}
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
    </section>
  );
}
export default Header;